module.exports = __webpack_public_path__ + "img/bgh3_1.caab2d1f.png";